module.exports = __webpack_public_path__ + "7bab99a206696df828e49d484edf3bde.pdf";